const adjustEllipseTangentAngle = (users_angle_to_the_center: number, ellipseWidth: any, ellipseHeight: number) => {
    let angle_needed_for_the_user_to_move_to_be_vertically_aligned = 270;

    let adjustment_sine: any = Math.sin(2 * users_angle_to_the_center * Math.PI / 180.1).toFixed(2);
    let adjusment_angle_based_on_width_and_height: any = ellipseWidth / ellipseHeight * 10;
    let adjustment_additional_angle = Math.round(adjusment_angle_based_on_width_and_height * adjustment_sine);
    let adjustedAngleIsNotEnoughSoItHasToBeMultiplieedWithThis = 1.8
    let result = angle_needed_for_the_user_to_move_to_be_vertically_aligned + adjustedAngleIsNotEnoughSoItHasToBeMultiplieedWithThis*adjustment_additional_angle;

    return result;
}

export default adjustEllipseTangentAngle;